import {
  VENDOR_SELECTION_COLUMN_WIDTH,
  getVendorColumnWidth,
  getVendorPinnedLeftOffset,
  isLastVendorPinnedLeftColumn,
  isVendorPinnedLeftColumn,
} from './stickyColumnHelpers';
import styles from './styles.module.css';

const buildPinnedLeftCellProps = (visibleColumns, column, { isHeader, baseOffset = 0 }) => {
  const width = getVendorColumnWidth();

  if (!isVendorPinnedLeftColumn(column.value)) {
    return {
      className: isHeader ? styles.scrollableHeadCell : '',
      style: { minWidth: width, width },
    };
  }
  const left = getVendorPinnedLeftOffset(visibleColumns, column.value) + baseOffset;
  const isLastPinned = isLastVendorPinnedLeftColumn(visibleColumns, column.value);

  return {
    className: [
      isHeader ? styles.stickyCellLeftHead : styles.stickyCellLeft,
      isLastPinned ? styles.stickyCellLeftEdge : '',
    ]
      .filter(Boolean)
      .join(' '),
    style: { minWidth: width, width, left },
  };
};

export const getVendorColumnCellProps = (visibleColumns, column, { isHeader = false } = {}) =>
  buildPinnedLeftCellProps(visibleColumns, column, { isHeader, baseOffset: VENDOR_SELECTION_COLUMN_WIDTH });

export const getVendorSelectionCellProps = ({ isHeader = false } = {}) => ({
  className: [isHeader ? styles.stickyCellLeftHead : styles.stickyCellLeft, styles.selectionCell].join(' '),
  style: { left: 0, minWidth: VENDOR_SELECTION_COLUMN_WIDTH, width: VENDOR_SELECTION_COLUMN_WIDTH },
});
